import z from "zod";

export const modalUploadDeliveryNoteFormSchema = z.object({
  deliveryNotes: z.array(
    z.object({
      deliveryDate: z
        .date()
        .optional()
        .refine((data) => data, {
          message: "cardAddDeliveryNote.deliveryNote.errorDeliveryDate",
        }),
      fileSignedId: z
        .string()
        .optional()
        .refine((data) => data, {
          message: "cardAddDeliveryNote.deliveryNote.errorDropfile",
        }),
      orderItemIds: z.array(z.string()),
    })
  ),
  validate: z.enum(["deliveryNote", "noDeliveryNote"], {
    message: "cardAddDeliveryNote.validate.errorLabel",
  }),
});

export type InferredModalUploadDeliveryNoteSchema = z.infer<
  typeof modalUploadDeliveryNoteFormSchema
>;
